export default "__VITE_ASSET__Cpvb0MEf__"